import { useMemo, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../Redux/hooks";
import { resetState } from "../../Redux/actions/resetAction";
import {
  Avatar,
  Box,
  ListItemIcon,
  Menu,
  MenuItem,
  Typography,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import http from "../../utils/http";
import { AxiosResponse } from "axios";
import { toastMessage } from "../../utils/toast";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { LogoutOutlinedIcon } from "../Common/assets/Icons";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";

const UserProfileCard = ({ collapsed }: any) => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const role = useAppSelector((state) => state.user.role);
  const firstName = useAppSelector((state) => state.user.firstName);
  const lastName = useAppSelector((state) => state.user.lastName);
  const userName = `${firstName ? firstName : ""} ${lastName ? lastName : ""}`;

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const avatarCharacter = useMemo(() => {
    let char = "";
    if (firstName) {
      char += firstName[0];
    }
    if (lastName) {
      char += lastName[0];
    }
    if (!char) {
      char = "U";
    }
    return char;
  }, [firstName, lastName]);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const logout = async () => {
    try {
      let url = "";
      if (role === "participant") {
        url = "/participant/auth/logout";
      } else {
        url = "/user/auth/logout";
      }
      let res: AxiosResponse;
      res = await http.post(url);
      toastMessage("success", res?.data?.message);
    } catch (err) {
      console.log(err);
    } finally {
      localStorage.clear();
      dispatch(resetState());
      if (role === "participant") {
        navigate("/auth/participant/login");
      } else {
        navigate("/auth/login");
      }
    }
  };

  return (
    <>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          cursor: "pointer",
          flex: 1,
          width: "100%",
        }}
        onClick={handleClick}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 1,
            flex: 1,
            minWidth: 0,
          }}
        >
          <Avatar
            sx={{
              height: "36px",
              width: "36px",
              backgroundImage: "linear-gradient(to right, #872EE5, #190DD7)",
              color: "#FFF",
              fontSize: "12px",
              fontWeight: "500",
              textTransform: "capitalize",
              flexShrink: 0,
            }}
          >
            {avatarCharacter}
          </Avatar>

          {!collapsed && (
            <Typography
              variant="body2"
              color="#FFF"
              fontWeight="regular"
              textTransform="capitalize"
              noWrap
              sx={{
                minWidth: "13ch",
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
            >
              {userName}
            </Typography>
          )}
        </Box>

        {!collapsed && (
          <ChevronRightIcon sx={{ color: "#FFF", ml: 1, flexShrink: 0 }} />
        )}
      </Box>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        // anchorOrigin={{
        //   vertical: -8,
        //   horizontal: "right",
        // }}
        // transformOrigin={{
        //   vertical: "top",
        //   horizontal: "left",
        // }}
        sx={{
          mt: 0.75,
          borderRadius: "12px",
        }}
      >
        <Box
          sx={{
            height: "131px",
            width: "267px",
            bgcolor: "#F3EDFF",
            m: "5px 14px",
            borderRadius: "6px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: 1,
            }}
          >
            <Avatar
              sx={{
                height: "50px",
                width: "50px",
                backgroundImage:
                  "linear-gradient(to top right, #F745D1, #B405EC, #2768C1)",
                color: "#FFF",
                fontSize: "26px",
                fontWeight: "600",
                textTransform: "capitalize",
              }}
            >{`${userName?.[0]}`}</Avatar>
            <Typography
              variant="body1"
              color="#1F2A37"
              fontWeight="medium"
              textTransform={"capitalize"}
            >
              {userName}
            </Typography>
            {/* <Typography
              variant="body2"
              color="#4B5563"
              textTransform={"capitalize"}
            >
              Role : {role}
            </Typography> */}
          </Box>
        </Box>
        {role !== "participant" && (
          <MenuItem
            onClick={() => {
              handleClose();
              navigate("/app/user-settings");
            }}
          >
            <ListItemIcon>
              <SettingsOutlinedIcon />
            </ListItemIcon>
            <Typography variant="body1" fontWeight="regular">
              Settings
            </Typography>
          </MenuItem>
        )}
        <MenuItem onClick={logout}>
          <ListItemIcon>
            <LogoutOutlinedIcon />
          </ListItemIcon>
          <Typography
            variant="body1"
            fontWeight="regular"
            sx={{ color: "#F05252" }}
          >
            Logout
          </Typography>
        </MenuItem>
      </Menu>
    </>
  );
};

export default UserProfileCard;
